export default __webpack_public_path__ + "static/media/Good.d1871cb3.png";